import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetAcceptedOffers } from 'cpool-tables/backend-resolvers';

import { ConsorsOfferInfoDialog } from './ConsorsOfferInfoDialog';
import { EuropaceOfferInfoDialog } from './EuropaceOfferInfoDialog';
import type { OfferEntry } from '~/features/leadDetails/components/BankCreditRequest/OfferHistory/schemas/offers.schema';

type Props = {
    isOpen: boolean;
    offer: SchemaLoanRequestResolver_GetAcceptedOffers[number] | OfferEntry;
    onClose: () => void;
};

export const OfferInfoDialog = ({ isOpen, offer, onClose }: Props) => {
    const europaceOfferId = 'applicationId' in offer ? offer.applicationId : null;

    switch (offer.source) {
        case LOAN_REQUEST_OFFER_SOURCES.EUROPACE:
        case LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC:
            return (
                <EuropaceOfferInfoDialog
                    europaceOfferId={europaceOfferId}
                    isOpen={isOpen}
                    offer={offer}
                    onClose={onClose}
                />
            );
        case LOAN_REQUEST_OFFER_SOURCES.CONSORS:
            return <ConsorsOfferInfoDialog acceptedOffer={offer} isOpen={isOpen} onClose={onClose} />;
        default:
            return null;
    }
};
